export default "__VITE_ASSET__CMQi5qwK__"